import dayjs from "dayjs";

export function getVendorStatementQueryRange(firstDay, lastDay) {
  const start = dayjs(firstDay);
  const end = dayjs(lastDay);

  if (!start.isValid() || !end.isValid()) {
    return null;
  }

  return {
    from: start.startOf("day").toDate().toISOString(),
    to: end.endOf("day").toDate().toISOString(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

export function getVendorStatementCurrentMonth(referenceDate = new Date()) {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  return {
    monthString: firstDay.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    }),
    firstDay,
    lastDay,
  };
}

export function hasVendorStatementOrders(orders) {
  return Array.isArray(orders) && orders.length > 0;
}
